export const Authorization = 'Authorization';
export const Token = 'token';
export const UserInfo = 'userInfo';
export const PartnerToken = 'PartnerToken';
export const AuthorizationPartnerToken = 'PartnerAuthorization';

